import { networkCode, type SlotConfig } from "./config";

export function createSlot(
  slotConfig: SlotConfig,
  targeting: Record<string, string | string[]>,
  divId?: string,
  tier?: string,
) {
  const { adUnitCode, sizes, sizeMapping, adUnitSubVersion } = slotConfig;

  // Switch to a test namespace for adunits when in testing mode.
  const adUnitRoot =
    `/${networkCode}` + (targeting.zTestEnabled ? "/ztest-0" : "");

  const adUnitPath =
    slotConfig.tiers.length && tier !== undefined
      ? `${adUnitRoot}/${adUnitCode}/${tier}-${adUnitSubVersion}`
      : `${adUnitRoot}/${adUnitCode}`;

  const slot = window.googletag
    .defineSlot(adUnitPath, sizes, divId)!
    .addService(window.googletag.pubads())
    .updateTargetingFromMap(targeting);

  // Responsively size ads based on viewport width
  if (sizeMapping) {
    slot.defineSizeMapping(sizeMapping);
  }

  return slot;
}
